/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { SwipeableList, Type as ListType } from 'react-swipeable-list';
import { DenominationFooter } from 'components/pages/collection';
import { NoData } from 'components';
import { Box } from 'atoms';
import { RejectSalesInvoiceSwipeWrapper } from 'components/pages/collection-app/swiple-invoiceCard/RejectSalesInvoiceSwipeWrapper';

const Cards = styled(Box)`
	max-height: 75vh;
	padding-bottom: 2rem;
	overflow: auto;
`;

export default function SalesmanRejectCollection() {
	const { SalesRejectedInvoices = [], SalesRejectedInvoicesFiltered = [] } = useSelector(
		(state) => state.salesman
	);

	console.log(SalesRejectedInvoices, 'SALESMAN REJECT');
	console.log(SalesRejectedInvoices);

	const stores_id = SalesRejectedInvoices.map((item) => item.store_id);

	console.log(stores_id, 'stores_id');

	return (
		<>
			{SalesRejectedInvoicesFiltered?.length === 0 ? (
				<>
					<NoData>Invoice Not Available</NoData>
					{/* <AddInvoice /> */}
				</>
			) : (
				<Cards>
					{SalesRejectedInvoicesFiltered?.length > 0 ? (
						<>
							<SwipeableList fullSwipe={false} threshold={0.25} type={ListType.IOS}>
								{SalesRejectedInvoicesFiltered?.map((invoice) => (
									<RejectSalesInvoiceSwipeWrapper
										key={invoice?.id}
										store_id={invoice?.store_id}
										invoice={invoice}
									/>
								))}
							</SwipeableList>
							{/* <AddInvoice /> */}
							{/* <AddInvoice /> */}
						</>
					) : (
						<NoData>Invoice Not Found</NoData>
					)}

					<DenominationFooter />
				</Cards>
			)}
		</>
	);
}
